import { createContext } from 'react';

// Dedicated module exporting only the AssociationsContext to keep exports stable
export const AssociationsContext = createContext({
  saveAssociationToDb: () => {},
  associations: [],
});

export default AssociationsContext;
